var Payment = xClass("MiQuickgamePayment")
Payment.prototype.ctor = function () {

}


Payment.prototype.buy = function (data, successCallback, failCallback, closeCallback) {
    let self = this

    console.warn("[####]call ks pay id:"+data.productId)
    let productId = data.productId

    function onSuccess(resp) {
        let data = resp.data
        let orderId = data.orderId;

        let orderInfo = JSON.parse(decodeURIComponent(data.orderInfo))
        
        console.warn("[################]ks pay getinfohttp success", data, "orderInfo", orderInfo)

        orderInfo.success = (result) => {
            console.warn("[######]success res:"+JSON.stringify(result))
            if (result.code == 1){
                successCallback && successCallback({orderId});
            }else{
                failCallback({
                    code: result.code,
                    data: result.msg,
                    msg: result.msg,
                })
            }
        }
        orderInfo.fail = (result) => {
            console.warn("[######]fail res:"+JSON.stringify(result))
            failCallback({
                code: result.code,
                data: result.msg,
                msg: result.msg,
            })
        }

        orderInfo.product_type = tonumber(orderInfo.product_type)
        orderInfo.buy_quantity = tonumber(orderInfo.buy_quantity)
        // let payment = {
        //     orderInfo: orderInfo,
        //     success: function() {
        //         successCallback && successCallback({orderId});
        //     },
        //     fail: function (res) {
        //         console.warn("[######]fail res:"+JSON.stringify(res))
        //         // let fail_type = self.getFailType(res.code);
        //         failCallback({
        //             code: res.resultStatus,
        //             data: res.memo,
        //             msg: res.memo,
        //         })
        //     }
        // }
        cc.log("ks pay", JSON.stringify(orderInfo))
        mini.pay(orderInfo)


       
        // let balance = data.balance
        // let cash = data.cash
        // //data.paySign//后端生成的签名的时间戳
        // console.warn("[#############]ks pay data "+ JSON.stringify(data))
        // if (!balance || balance < cash) {
        //     // 余额不足，充值

        // } 
        // else 
        // {
        //     // 余额够，不需要充值，直接购买
        //     //pay()
        // }
    }

    function onFail(evt) {
        cc.log("[################]getinfohttp failed" + evt.data)
        let errcode = evt ? evt.data : -1;
        failCallback({
            code: errcode,
            data: "初始化订单失败"
        })
    }

    function onCancel() {
        console.warn("[################]getinfohttp canecel")
        failCallback({
            code: -1,
            data: "初始化订单取消"
        })
    }

    let http = KsQuickgamePaymentGetInfoHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load({
        productId:productId,
        openid: META.user.openid,
        zoneId: META.user.serverid,
        sessionid: META.user.sessionid,
        engineVersion:META.platformVersion,
        ext: data.ext
    })
    console.warn("[####]ks pay:", {
        productId:productId,
        openid: META.user.openid,
        zoneId: META.user.serverid,
        sessionid: META.user.sessionid,
        engineVersion:META.platformVersion,
        ext: data.ext
    })
}

module.exports = Payment